enum Sections {
  AffordableCars = 'affordable-cars',
  CVTBanner = 'cvt-banner',
  FinanceCard = 'finance-card',
  FinanceTradePromoTiles = 'finance-trade-promo-tiles',
  Hero = 'hero',
  InternalLinks = 'internal-links',
  NewPriceBanner = 'new-price-banner',
  PopularBodyStyles = 'popular-body-styles',
  PopularModels = 'popular-models',
  RecentSearches = 'recent-searches',
  RecentlyViewed = 'recently-viewed',
  Recommended = 'recommended',
  SRPLinks = 'srp-links',
  SuggestedForYou = 'suggested-for-you',
  TradeCard = 'trade-card',
  ValueInsurancePromoTiles = 'value-insurance-promo-tiles',
  VDPLinks = 'vdp-links'
}

export default Sections;
